<template>
  <div class="game-status">
    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceIn"
      leave-active-class="animated bounceOut"
    >
      <!-- v-if="isCorrect!=='unset'" -->
      <div
        class="game-status-icon"
        v-show="gameCheckSwitch"
        :class="[{ 'correct-answer': isCorrect === 'correct' }, { 'wrong-answer': isCorrect === 'incorrect' }]"
      >
        <!-- <font-awesome-icon :icon="icon"
                       :mask="['far']"
                       size="9x" /> -->
        <!-- <span>Status</span>
    <span class="game-status-text"
          :class="{'wrong-answer':!isCorrect}">
          {{gameStatusText}}</span> -->
      </div>
    </transition>
  </div>
</template>

<script>
import _ from 'lodash';
// import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
// import { faStar } from '@fortawesome/fontawesome-free-regular';
export default {
  name: 'tr-game-status-v2',
  components: {
    // FontAwesomeIcon
  },
  props: {
    gameStatus: {
      type: String,
      default: function () {
        return false;
      },
    },
  },
  mounted: function () {
    // // console.log('Panel Statusu');
  },
  methods: {},
  computed: {
    isCorrect() {
      // console.log('isCorrect', this.gameStatus);
      return this.gameStatus;
    },
    gameCheckSwitch() {
      return this.$store.getters.gameCheckSwitch;
    },
    blockCheckAction() {
      return this.$store.getters.blockCheckAction;
    },
    // gameStatusText() {
    //   return this.isCorrect ? 'dobrze' : 'źle';
    // },
    // icon() {
    //   return faStar;
    // }
  },
};
</script>

<style lang="scss">
@import '~@/assets/sass/iconColor';
@import '~@/assets/sass/animation';
.game-status {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 954px;
  left: 1578px;
  width: 125px;
  height: 125px;
  // font-size: 30px;
  // border: solid 1px black;
  // border-radius: 50%;
  // width: 10%;
  // height: 18%;
  .game-status-icon {
    display: flex;
    padding: 5%;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    width: 100%;
    height: 100%;
    .game-status-text {
      color: green;
      padding-left: 10%;
    }
  }
  .correct-answer {
    background-image: url('~@/assets/icons/both/gameInterface/statusCorrect.png');

    // background-color: $iconStarFirstColor;
  }
  .wrong-answer {
    background-image: url('~@/assets/icons/both/gameInterface/statusWrong.png');

    // background-color: $iconStarFirstColor;
  }
  .unset-answer {
    opacity: 0;
    background-image: url('~@/assets/icons/both/gameInterface/statusCorrect.png');

    // background-color: $iconStarFirstColor;
  }
}
/**
 * hack dla scali i przesuniecia z canvasem w cwiczeniach
 * @type {[type]}
 */

.hack-game-status {
  transform: translate(-50%, -50%) scale(0.7) !important;
  left: 58.5% !important;
  top: 66.8% !important;
}
</style>
